if (!customElements.get("lsg-modal-dialog")) customElements.define("lsg-modal-dialog", class LSGModalDialog extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            trigger: ".js-modal-dialog-trigger",
            backdrop: ".js-modal-dialog-backdrop",
            dialog: ".js-modal-dialog",
            closeButton: ".js-modal-dialog-close-button",
            firstFocusableElement: ".js-modal-dialog-first-focusable-element",
            lastFocusableElement: ".js-modal-dialog-last-focusable-element",
            otherButtons: ".js-modal-dialog-close"
        };
        this.backdrop = this.querySelector(this.selectors.backdrop);
        this.dialog = this.querySelector(this.selectors.dialog);
        this.closeButton = this.querySelector(this.selectors.closeButton);
        this.firstFocusableElement = this.querySelector(this.selectors.firstFocusableElement);
        this.lastFocusableElement = this.querySelector(this.selectors.lastFocusableElement);
        this.otherButtons = this.querySelectorAll(this.selectors.otherButtons);
        this.init();

    }

    initTriggers() {
        // Open the dialog when the trigger button is activated.
        this.trigger = document.querySelectorAll(`${this.selectors.trigger}[data-id="${this.getAttribute("data-id")}"]`);
        this.trigger.forEach(el => {
            el.addEventListener("click", (e) => {

                this.openDialog(el);
            });
        });

    }

    openModal() {
        setTimeout(() => {
            this.backdrop.classList.add("is-visible");
            this.closeButton.focus();
            window.dispatchEvent(new Event('resize'));
            document.querySelector('body').classList.add('is-modal-show');
        },400);
    }

    init() {
        this.initTriggers();

        // Close the dialog when the inner close button is activated.
        this.closeButton.addEventListener("click", (e) => {
            this.closeDialog();
        });
        // Close the dialog when the user clicks on the backdrop.
        this.backdrop.addEventListener("click", (e) => {
            if (!this.dialog.contains(e.target)) this.closeDialog();
        });
        // Close the dialog when 'Escape' key is pressed.
        this.backdrop.addEventListener("keydown", (e) => {
            if (e.key == "Escape") this.closeDialog();
        });
        // Trap keyboard focus by moving focus to the first or last focusable element when the user tries to tab (or "backwards" tab) past them.
        this.dialog.addEventListener("keydown", (e) => {
            if (e.target == this.firstFocusableElement && e.key == "Tab" && e.shiftKey) {
                e.preventDefault();
                this.lastFocusableElement.focus();
            } else if (e.target == this.lastFocusableElement && e.key == "Tab" && !e.shiftKey) {
                e.preventDefault();
                this.firstFocusableElement.focus();
            }
        });
        // For code demo purposes only. Close the dialog when the Cancel or OK buttons are activated. In a real use case these might actually do something like set cookies or refresh the page or something.
        this.otherButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                this.closeDialog();
            });
        });
    }

    openDialog(el) {
        const url = el.getAttribute('data-url');

        if (url != null) {
            el.classList.add('is-loading');
            fetch(url).then(response => response.text())
                .then((response) => {
                    this.querySelector('.js-content').innerHTML = ` ${response}`;
                    this.querySelector('.js-content').querySelector('lsg-carousel-rebuild')?.remove();
                    setTimeout(() => {
                        el.classList.remove('is-loading');
                        this.backdrop.classList.add("is-visible");
                        this.closeButton.focus();
                        window.dispatchEvent(new Event('resize'));
                        document.querySelector('body').classList.add('is-modal-show');
                    }, 200);
                    return false;
                })
                .catch((error) => {
                    el.classList.remove('is-loading');
                    document.querySelector('body').classList.remove('is-modal-show');
                });
        } else {
            this.backdrop.classList.add("is-visible");
            this.closeButton.focus();
            document.querySelector('body').classList.add('is-modal-show');
        }

    }

    closeDialog() {
        this.backdrop.classList.remove("is-visible");
        this.trigger[0]?.focus();
        if (this.hasAttribute("data-remove-on-close")) {
            this.remove();
        } else {
            if (this.querySelector('.js-content') != null) {
                this.querySelector('.js-content').innerHTML = ``;
            }

        }
        document.querySelector('body').classList.remove('is-modal-show');
    }
});


